<template>
  <b-nav-item-dropdown class="region-dropdown" right :disabled="switching">
    <template v-slot:button-content>
      <span class="region-trigger">
        <i class="el-icon-location-outline"></i>
        <span>{{ currentRegion.toUpperCase() }}</span>
      </span>
    </template>
    <b-dropdown-item
      v-for="region in availableRegions"
      :key="region.code"
      :active="region.code === currentRegion"
      @click="switchRegion(region.code)"
    >
      <span class="region-option">
        <span class="region-option-code">{{ region.code.toUpperCase() }}</span>
        <span class="region-option-name">{{ region.name }}</span>
      </span>
    </b-dropdown-item>
  </b-nav-item-dropdown>
</template>

<script>
export default {
  name: 'RegionSwitcher',
  data() {
    return {
      switching: false
    }
  },
  computed: {
    currentRegion() {
      return this.$store.state.region.currentRegion
    },
    availableRegions() {
      return this.$store.state.region.availableRegions
    }
  },
  methods: {
    async switchRegion(region) {
      if (region === this.currentRegion || this.switching) return
      this.switching = true
      try {
        const changed = await this.$store.dispatch(
          'region/switchRegion',
          region
        )
        if (changed) window.location.reload()
      } catch (error) {
        this.switching = false
        this.$message.error(error.message || 'Failed to switch region')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.region-dropdown {
  margin-right: 12px;
}

.region-trigger {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  min-width: 56px;
  height: 30px;
  padding: 0 10px;
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 15px;
  color: #aab5c8;
  font-size: 12px;
  font-weight: 600;
  line-height: 30px;
}

.region-option {
  display: flex;
  align-items: center;
  width: 170px;
}

.region-option-code {
  flex: 0 0 30px;
  margin-right: 8px;
  color: #409eff;
  font-size: 11px;
  font-weight: 700;
}

.region-option-name {
  flex: 1;
}
</style>
